import React, { useState } from 'react';
import Modal from '@components/common/modal';

import RadioInput from '@components/common/radioInput';
import Button from '@components/common/button';
import Icon from '@components/common/assets';
import { JobSearchStatus, JobSearchStatusMap, JobSearchStatusType } from '@domain/constant/match/jobSearchStatus';
import classnames from 'classnames/bind';
import styles from './matchingStatusModal.module.scss';
const cx = classnames.bind(styles);

interface MatchingStatusModalProps {
  visible: boolean;
  onClose: () => void;
  jobSearchStatus: JobSearchStatusType;
  onClickConfirm: (jobSearchStatus: JobSearchStatusType) => void;
}

const MatchingStatusModal = ({ onClose, visible, jobSearchStatus, onClickConfirm }: MatchingStatusModalProps) => {
  const [searchStatus, setSearchStatus] = useState<JobSearchStatusType>(jobSearchStatus);

  const onRadioChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchStatus(e.target.value as JobSearchStatusType);
  };

  const onClickConfirmButton = () => {
    if (searchStatus !== jobSearchStatus) {
      onClickConfirm(searchStatus);
    }

    onClose();
  };

  return (
    <Modal visible={visible}>
      <div className={cx('matchingStatusModal')}>
        <a role="button" className={cx('closeBtn')} onClick={onClose}>
          <Icon name="closeLight" width={32} height={32} />
        </a>
        <div className={cx('title')}>구직 상태</div>
        <div className={cx('description')}>받고 싶은 제안의 종류에 따라 구직 상태를 설정해주세요.</div>

        <div className={cx('searchStatus')}>
          {/* 적극적으로 취업/이직을 준비 중이에요. */}
          <RadioInput
            label={JobSearchStatusMap[JobSearchStatus.ACTIVE_SEARCH]}
            value={JobSearchStatus.ACTIVE_SEARCH}
            name="searchStatus"
            checked={searchStatus === 'ACTIVE_SEARCH'}
            onChange={onRadioChange}
          />

          {/* 좋은 제안이 있으면 받고 싶어요. */}
          <RadioInput
            label={JobSearchStatusMap[JobSearchStatus.OPEN_TO_OFFERS]}
            value={JobSearchStatus.OPEN_TO_OFFERS}
            name="searchStatus"
            checked={searchStatus === 'OPEN_TO_OFFERS'}
            onChange={onRadioChange}
          />
        </div>

        <div className={cx('buttons')}>
          <Button className={cx('button')} onClick={onClickConfirmButton}>
            확인
          </Button>
        </div>
      </div>
    </Modal>
  );
};

export default MatchingStatusModal;
